import Component from '@glimmer/component';

import { concat } from '@ember/helper';

import CIcon from 'rise-ui/components/c-icon.gjs';
import DropdownListButton from 'rise-ui/components/dropdown-list-button.gjs';
import imageDownloadSizes from 'rise-ui/helpers/image-download-sizes.js';
import linkToDownloadTimeSeriesOutputs from 'rise-ui/helpers/link-to-download-time-series-outputs.js';

export default class TimeSeriesOutputLineDownloadComponent extends Component {
  <template>
    <DropdownListButton
      @disabled={{@disabled}}
      @side="bottom-end"
      @title="Download as a File"
      as | ddlb |
    >
      <ddlb.button>
        <CIcon @icon="download" />
        View/Download
      </ddlb.button>
      <ddlb.link
        @key="csv"
        @urlOpen={{linkToDownloadTimeSeriesOutputs
          "csv" @filename
          id=@outputId
          disposition="inline"
          isModeled=@isModeled
        }}
        @title="View Data as CSV File"
      >
        View CSV
      </ddlb.link>
      <ddlb.link
        @key="json"
        @urlOpen={{linkToDownloadTimeSeriesOutputs
          "json" @filename
          id=@outputId
          disposition="inline"
          isModeled=@isModeled
        }}
        @title="View Data as JSON File"
      >
        View JSON
      </ddlb.link>
      <ddlb.link
        @key="csv"
        @noOpenIcon={{true}}
        @urlOpen={{linkToDownloadTimeSeriesOutputs
          "csv" @filename
          id=@outputId
          isModeled=@isModeled
        }}
        @target="_self"
        @title="Download Data as CSV File"
      >
        Download CSV
      </ddlb.link>
      <ddlb.link
        @key="json"
        @noOpenIcon={{true}}
        @urlOpen={{linkToDownloadTimeSeriesOutputs
          "json" @filename
          id=@outputId
          isModeled=@isModeled
        }}
        @target="_self"
        @title="Download Data as JSON File"
      >
        Download JSON
      </ddlb.link>
      <ddlb.heading>Select desired image size in megapixels (MP)</ddlb.heading>
      {{#each (imageDownloadSizes) as | preset |}}
        <ddlb.item
          @key={{concat preset.width "," preset.height}}
          @disabled={{@imageDisabled}}
          @onClick={{@onSelectImage}}
        >
          Download Image
          {{preset.width}}&times;{{preset.height}} ({{preset.label}})
        </ddlb.item>
      {{/each}}
    </DropdownListButton>
  </template>
}
